module.exports = __webpack_public_path__ + "static/media/tiotom-svg-white.21083c15.svg";